<ng-content />

@if (shouldOpenInNewTab) {
  <span class="ml-1" [attr.aria-label]="'Opens in new tab'">
    <svg ftrIcon="OpenInNew" [iconSize]="18"></svg>
  </span>
}
